import type SVGType from 'types/svg.types';

const ExpensesIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="receipt-3">
      <path
        id="Icon"
        d="M12.5334 11.4669H19.4667M12.5334 15.7335H15.2001M23.7334 25.8669V8.26688C23.7334 7.08867 22.7783 6.13354 21.6001 6.13354H10.4001C9.22185 6.13354 8.26672 7.08867 8.26672 8.26688V25.8669L11.0223 23.4669L13.5112 25.8669L16.0001 23.4669L18.4889 25.8669L20.9778 23.4669L23.7334 25.8669Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default ExpensesIcon;
